import { CircularProgress } from '@llt-frontend/react-material-progress';
import PropTypes from 'prop-types';
import React from 'react';
import { SearchableMenu } from '@llt-frontend/react-material-menu/dist';
import { useFetch } from '@llt-frontend/react-fetch';
import { useTranslation } from 'react-i18next';

// Internal
// --------

function SubjectSelect({ initialValue, onChange }) {
  const { t, ready: translationLoaded } = useTranslation('self-service/packages/subject-select');

  // Setup

  const subjectsApiPath = `${process.env.REACT_APP_API_HOST}/vtwa/v5/subjects?tutoring_session_enabled=true&alphabetical=true&include_is_leaf=false`;
  const subjects = useFetch(subjectsApiPath);

  //
  // Methods

  function getSubjects() {
    if (subjects?.status === 'loading') {
      return [
        {
          primaryText: translationLoaded && t('loading'),
        },
      ];
    }

    if (!subjects?.data) {
      return [
        {
          className: 'mdc-list-item--error',
          primaryText: translationLoaded && t('loadError'),
          value: null,
        },
      ];
    }

    return subjects.data.map(({ id, display_name }) => ({
      primaryText: display_name,
      selected: id.toString() === initialValue,
      value: id.toString(),
    }));
  }

  function handleItemSelect(value, primaryText) {
    if (!value) {
      return;
    }
    onChange && onChange(value, primaryText);
  }

  //
  // Render

  if (!subjects?.data && initialValue) {
    return (
      <div className="package-selector__subject-select__loading">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="package-selector__subject-select">
      <label className="select-label">{translationLoaded && t('subject')}</label>
      <SearchableMenu
        id="select-subject"
        items={getSubjects()}
        placeholder={translationLoaded ? t('chooseSubject') : ''}
        onItemSelection={handleItemSelect}
        value={initialValue}
      />
    </div>
  );
}
SubjectSelect.propTypes = {
  onChange: PropTypes.func,
};

// External
// --------

export default SubjectSelect;
